<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="col brand">
        <img :src="logoSrc" alt="GTL" class="logo"/>
        <p class="line"><strong>{{$t('footer_电话')}}</strong><span>0591-22970811</span></p>
        <p class="line"><strong>WhatsApp</strong><span></span></p>
        <p class="line"><strong>{{$t('footer_邮箱')}}</strong><span><a href="mailto:sales@jdlpower.com">sales@jdlpower.com</a></span></p>
      </div>
      <div class="col links">
        <h4>{{$t('footer_快速链接')}}</h4>
        <ul>
          <li><a @click.prevent="$router.push('/')">{{$t('首页')}}</a></li>
          <li><a @click.prevent="$router.push('/product')">{{$t('产品')}}</a></li>
          <li><a @click.prevent="$router.push('/industry')">{{$t('行业')}}</a></li>
          <li><a @click.prevent="$router.push('/download')">{{$t('支持')}}</a></li>
          <li><a @click.prevent="$router.push('/aboutus')">{{$t('关于我们')}}</a></li>
          <li><a @click.prevent="$router.push('/news')">{{$t('博客')}}</a></li>
          <li><a @click.prevent="$router.push('/contactus')">{{$t('联系我们')}}</a></li>
<!--          <li><a @click.prevent="go('/news')">网站地图</a></li>-->
<!--          <li><a @click.prevent="go('/news')">隐私政策</a></li>-->
        </ul>
      </div>
      <div class="col links">
        <h4>{{$t('footer_产品类别')}}</h4>
        <ul>
          <li @click.prevent="$router.push(`/category/${this.$t('柴油发电机组')}`)"><a>{{$t('柴油发电机组')}}</a></li>
          <li @click.prevent="$router.push(`/category/${this.$t('空气压缩机')}`)"><a>{{$t('空气压缩机')}}</a></li>
          <li @click.prevent="$router.push(`/category/${this.$t('灯塔')}`)"><a>{{$t('灯塔')}}</a></li>
          <li @click.prevent="$router.push(`/category/${this.$t('冷藏发电机')}`)"><a>{{$t('冷藏发电机')}}</a></li>
          <li @click.prevent="$router.push(`/category/${this.$t('燃气发电机组')}`)"><a>{{$t('燃气发电机组')}}</a></li>
          <li @click.prevent="$router.push(`/category/${this.$t('电焊机')}`)"><a>{{$t('电焊机')}}</a></li>
        </ul>
      </div>
      <div class="col form">
        <h4>{{$t('footer_立即联系我们')}}</h4>
        <form @submit.prevent="submit">
          <input v-model="model.company" type="email" :placeholder="$t('footer_电子邮件placeholder')" required/>
          <input v-model="model.name" type="text" :placeholder="$t('footer_姓名')"/>
          <input v-model="model.phone" type="text" :placeholder="$t('footer_电话placeholder')" required/>
          <textarea v-model="model.message" rows="4" :placeholder="$t('footer_信息')"></textarea>
          <button type="submit" class="outline-pill">{{$t('footer_提交')}}</button>
        </form>
      </div>
    </div>
    <div class="legal">
      <p>{{$t('footer_版权')}}</p>
      <div class="legal-socials">
        <span title="Weibo">Wb</span>
        <span title="WeChat">Wx</span>
        <span title="Douyin">Dy</span>
        <span title="TikTok">Tt</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    logoSrc: {type: String, default: () => require('@/assets/logo.png')}
  },
  data() {
    return {
      model: {company: '', name: '', phone: '', message: ''}
    }
  },
  methods: {
    submit() {
      // 检查 Tawk.to 是否已加载
      if (typeof window.Tawk_API === 'undefined') {
        console.warn('Tawk.to API 未加载')
        // 如果 Tawk.to 未加载，仍然触发原有事件
        this.$emit('contact', {...this.model})
        this.model = {company: '', name: '', phone: '', message: ''}
        return
      }

      try {
        // 保存表单数据用于后续使用
        const formData = {
          name: this.model.name || '访客',
          email: this.model.company || '',
          phone: this.model.phone || '',
          message: this.model.message || ''
        }

        // 验证邮箱格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const isValidEmail = formData.email && emailRegex.test(formData.email)

        // 设置访客属性（姓名、邮箱、电话）
        // 只设置有效的邮箱，避免 INVALID_EMAIL 错误
        const attributes = {
          'name': formData.name
        }
        
        // 只在邮箱格式有效时添加邮箱属性
        if (isValidEmail) {
          attributes['email'] = formData.email
        }
        
        // 只在有电话时添加电话属性
        if (formData.phone) {
          attributes['phone'] = formData.phone
        }

        window.Tawk_API.setAttributes(attributes, (error) => {
          if (error) {
            console.error('设置 Tawk.to 访客属性失败:', error)
            // 如果设置属性失败，仍然继续执行其他操作
          }
        })

        // 添加自定义事件来记录表单提交
        // Tawk.to 事件名称需要使用下划线分隔，且不能包含特殊字符
        // 使用更简单的事件名称格式
        const eventData = {
          name: formData.name,
          phone: formData.phone,
          message: formData.message
        }
        
        // 只在邮箱有效时添加到事件数据
        if (isValidEmail) {
          eventData.email = formData.email
        }

        // 使用简单的事件名称
        window.Tawk_API.addEvent('form_submit', eventData, (error) => {
          if (error) {
            console.warn('添加 Tawk.to 事件失败（这不会影响表单提交）:', error)
            // 事件添加失败不影响主要功能，只记录警告
          }
        })

        // 构建预填充消息内容
        let prefillMessage = `联系表单提交信息：\n`
        if (formData.name) {
          prefillMessage += `姓名：${formData.name}\n`
        }
        if (formData.email) {
          prefillMessage += `邮箱：${formData.email}\n`
        }
        if (formData.phone) {
          prefillMessage += `电话：${formData.phone}\n`
        }
        if (formData.message) {
          prefillMessage += `留言：${formData.message}`
        }

        // 打开聊天窗口并预填充消息
        // 注意：Tawk.to 不直接支持程序化发送消息，但可以通过设置访客属性和打开聊天窗口
        // 客服可以在 Tawk.to 后台看到访客信息和事件记录
        window.Tawk_API.maximize()

        // 尝试使用 Tawk.to 的预填充功能（如果支持）
        // 这需要在 Tawk.to 后台配置相应的设置
        if (window.Tawk_API.onReady) {
          window.Tawk_API.onReady(() => {
            // 如果 Tawk.to 支持预填充消息，可以在这里设置
            // 注意：这取决于 Tawk.to 的具体版本和配置
            console.log('Tawk.to 已就绪，表单数据已设置')
          })
        }

        // 触发原有事件（保持向后兼容）
        this.$emit('contact', {...this.model})
        
        // 清空表单
        this.model = {company: '', name: '', phone: '', message: ''}

        // 显示成功提示（可选）
        if (this.$message || (window.alert && !window.alert.disabled)) {
          // 如果使用了消息提示组件，可以在这里显示
          console.log('表单已提交，聊天窗口已打开')
        }
      } catch (error) {
        console.error('提交表单到 Tawk.to 失败:', error)
        // 失败时仍然触发原有事件
        this.$emit('contact', {...this.model})
        this.model = {company: '', name: '', phone: '', message: ''}
      }
    },
    go(path) {
      if (this.$router) this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: #141516;
  color: #cfd6df;
  text-align: left;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 44px 16px;
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1.6fr;
  gap: 32px 48px;
  text-align: left;
}

.col h4 {
  margin: 0 0 14px;
  font-size: 18px;
  color: #fff;
  letter-spacing: .5px;
}

.logo {
  height: 56px;
  margin-bottom: 16px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, .25));
}

/* 联系信息分隔与层级 */
.brand .line {
  margin: 0 0 14px;
  padding: 10px 0 14px;
  border-bottom: 1px solid #2a2d31;
}

.brand .line:last-of-type {
  border-bottom: 1px solid #2a2d31;
}

.brand .line strong {
  display: block;
  color: #9fb0c3;
  font-size: 13px;
  letter-spacing: .5px;
}

.brand .line span {
  display: block;
  color: #e9eef5;
  font-size: 20px;
  font-weight: 600;
  margin-top: 6px;
}

.brand a {
  color: #e9eef5;
  text-decoration: none;
}

.brand a:hover {
  color: #ffffff;
}

/* 链接列 */
.links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.links li {
  margin: 10px 0;
  padding-left: 18px;
  position: relative;
}

.links li::before {
  content: '›';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-52%);
  color: #999999;
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  margin-top: -2px;
}

.links a {
  color: #cfd6df;
  text-decoration: none;
  cursor: pointer;
  transition: color .2s ease, border-color .2s ease, transform .15s ease;
  display: inline-block;
  border-bottom: 1px solid transparent;
  line-height: 1.7;
}

.links a:hover {
  color: #ffffff;
  transform: translateX(1px);
}

.links a:focus-visible {
  outline-offset: 2px;
  border-radius: 2px;
}

/* 表单 */
.form form {
  display: grid;
  gap: 12px;
}

.form input, .form textarea {
  background: #232527;
  border: 1px solid #4a4f56;
  color: #eaeef5;
  padding: 12px 14px;
  border-radius: 6px;
}

.form input::placeholder, .form textarea::placeholder {
  color: #b7bcc5;
}

.form input:focus, .form textarea:focus {
  outline: none;
  border-color: #ffffff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, .06);
}

/* 胶囊描边按钮 */
.outline-pill {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  padding: 10px 68px;
  border-radius: 26px;
  width: fit-content;
  cursor: pointer;
}

.outline-pill:hover {
  background: #ffffff;
  color: #141516;
}

.socials {
  margin-top: 12px;
  display: flex;
  gap: 12px;
  color: #96a2b2;
}

.socials span {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #1c1e20;
  display: grid;
  place-items: center;
  font-size: 12px;
}

.socials span:hover {
  color: #fff;
}

/* 版权与社交 */
.legal {
  border-top: 1px solid #222;
  text-align: left;
  padding: 14px 16px;
  color: #8b98a8;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.legal-socials {
  display: flex;
  gap: 10px;
}

.legal-socials span {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ffffff;
  color: #141516;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 1100px) {
  .footer-inner {
    grid-template-columns: 1fr 1fr;
  }

  .brand .line span {
    font-size: 18px;
  }

  .links li {
    margin: 12px 0;
  }

  .legal {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

@media (max-width: 640px) {
  .footer-inner {
    grid-template-columns: 1fr;
  }

  .brand .line {
    padding-bottom: 12px;
  }
}
</style>
